import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule, LOCALE_ID } from '@angular/core';
import { AppRoutingModule } from '../app-routing.module';
import { SharedModule } from '../shared/shared.module';
import { HeaderComponent } from './components/header/header.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TransferState } from '@angular/platform-browser';
import { CustomTranslateLoader } from './services/translate/custom-translate-loader.service';
import { CookiesMsgComponent } from './components/cookies-msg/cookies-msg.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { UnderMaintenanceComponent } from './components/under-maintenance/under-maintenance.component';
import {FooterComponent} from '@core/components/footer/footer.component';

export function HttpLoaderFactory(httpClient: HttpClient): CustomTranslateLoader {
  return new CustomTranslateLoader(httpClient, 'core');
}

@NgModule({
  declarations: [
    HeaderComponent,
    CookiesMsgComponent,
    NotFoundComponent,
    UnderMaintenanceComponent,
    FooterComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      isolate: true
    }),
    SharedModule
  ],
  providers: [
    HttpClient,
    TransferState
  ],
  exports: [
    HeaderComponent,
    CookiesMsgComponent,
    SharedModule,
    HttpClientModule,
    AppRoutingModule,
    FooterComponent
  ]
})
export class CoreModule { }
